<div class="">
  <!------------------------------------------ HEADER IMAGE --------------------------------------->
  <!------------------------------------------TITLE----------------------------------------------->
  <div class="title-box uk-border-rounded p-1  ">
    <div class="head-card p-1 inner-title-box">
      <h1 class="title-text text-center font-weight-bold">Gallery</h1>
     
    </div>
  </div>
  <!--------------------------------------------------TITLE END-------------------------------------------->
  <!------------------------------------------ END ------------------------------------------------->

  <!------------------------------------------ WEBSITES---------------------------------------------->
  <div class="bg-light">
    <div class="container-fluid">
      <!-- Page Title -->
      <h4
        class="font-weight-bolder align-middle text-center text-uppercase d-block d-sm-none"
      >
        Gallery
      </h4>
<div class="gallery-container">
  <div *ngIf="images1.length === 0">No images available.</div>
  <div *ngFor="let image of images1" class="image-item">
    <div class="image-wrapper">
      <img
        *ngIf="image.url"
        [src]="image.url"
        [alt]="image.name"
        class="img-thumbnail mt-2"
      />
    </div>
  </div>
</div>



      
    </div>
  </div>
</div>
<!--------------------------------------- MOBILE VIEW ------------------------------------------------->

 <!-- <div class="d-block d-sm-none">

<div class="gallery-container">
  <div *ngIf="images1.length === 0">No images available.</div>
  <div *ngFor="let image of images1" class="image-item">
    <div class="image-wrapper">
      <img
        *ngIf="image.url"
        [src]="image.url"
        [alt]="image.name"
        class="img-thumbnail mt-2"
      />
    </div>
  </div>
</div>
 
</div> -->
